import apiClient from "./axios"

export const getAccountFundTransfers = async (params = {}) => {
  const response = await apiClient.get('/account-fund-transfers', { params })
  return response.data
}

export const getAccountFundTransfer = async (id) => {
  const response = await apiClient.get(`/account-fund-transfers/${id}`)
  return response.data
}

export const createAccountFundTransfer = async (payload) => {
  const response = await apiClient.post('/account-fund-transfers', payload)
  return response.data
}

export const updateAccountFundTransfer = async (id, payload) => {
  const response = await apiClient.patch(`/account-fund-transfers/${id}`, payload)
  return response.data
}

export const deleteAccountFundTransfer = async (id) => {
  const response = await apiClient.delete(`/account-fund-transfers/${id}`)
  return response.data
}
